import { ProjectDrawingsPage } from '@/features/bom-import/pages/project-drawings-page'
import { drawingFilesQuery } from '@/features/bom/queries/pickers-queries'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/projects/$projectId/_layout/drawings')({
  loader: ({ params, context }) =>
    context.queryClient.ensureQueryData(drawingFilesQuery(params.projectId)),
  component: RouteComponent,
  staticData: { crumb: messages.crumbs.drawings },
})

function RouteComponent() {
  const { projectId } = Route.useParams()
  return <ProjectDrawingsPage projectId={projectId} />
}
